import styled from 'styled-components';

export const CardContainer = styled.div`
  box-shadow: ${props =>
    props.hovered ? '0px 15px 40px rgba(11, 26, 33, 0.1)' : '0px 3px 10px rgba(11, 26, 33, 0.08)'};
  cursor: ${props => (props.hovered ? 'pointer' : 'arrow')};
  height: 100%;
  transition: all 0.25s cubic-bezier(0.55, 0.085, 0.68, 0.53);
  position: relative;
  display: flex;
  flex-direction: column;

  .card--top-left-icon {
    img {
      width: 40px;
      height: 40px;
    }
    position: absolute;
    top: 25px;
    left: 15px;
    z-index: 1;
  }

  .card--cover {
    position: relative;
    height: auto;
    ${props => (!props.fullCoverImage ? `min-height: 217px;` : '')};
    background: ${props => props.coverBackColor || '#ffffff'};

    &.has-top-left-icon {
      margin-left: 40px;
    }

    .card--cover-video {
      min-height: 217px;
    }

    .card--cover-overlay {
      position: absolute;
      z-index: 2;
      display: flex;
      align-self: center;
      width: auto;
      top: 50%;
      transform: translateY(-50%);
    }

    .card--cover-image {
      height: 100%;
      ${props => (!props.fullCoverImage ? `min-height: 218px; max-height: 251px;` : '')};
    }

    .card--cover-mark-icon {
      width: 40px;
      height: 40px;
      position: absolute;
      top: 12px;
      left: 12px;
      background: white;
      border-radius: 50%;
      padding: 9px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        max-width: 100%;
        max-height: 100%;
      }
    }
  }

  .card--body {
    background: ${props => props.bodyBackColor || '#ffffff'};
    height: 100%;

    &.has-top-left-icon {
      margin-left: 40px;
    }
  }

  .card--link {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }

  &.no-shadow {
    box-shadow: none;
  }

  &.side-cover {
    flex-direction: row;
    &.side-reverse {
      flex-direction: row-reverse;
    }

    .card--cover {
      flex: 1;
      overflow: hidden;
      min-height: 0;
      max-height: 100%;

      .card--cover-image {
        min-height: 0;
        max-height: 476px;
      }

      .card--cover-video {
        max-height: 100%;
        height: 100%;
      }
    }

    .card--body {
      width: 403px;
      max-width: 50%;
      height: auto;
    }

    @media (max-width: 768px) {
      .card--cover {
        width: 50%;
      }

      .card--body {
        width: 50%;
      }
    }

    @media (max-width: 576px) {
      flex-direction: column;
      &.side-reverse {
        flex-direction: column;
      }

      .card--cover {
        width: 100%;
        flex: auto;

        .card--cover-image,
        .card--cover-video {
          width: 100%;
          height: auto;
        }
      }

      .card--body {
        width: 100%;
        max-width: 100%;
        flex: 1;
      }
    }
  }

  &.simple-responsive {
    @media (max-width: 768px) {
      flex-direction: row;
      align-items: center;
      background: ${props => props.bodyBackColor || '#ffffff'};

      .card--cover {
        min-width: 100px;
        min-height: 0;

        .card--cover-image {
          height: 100px;
          min-height: 0;
          max-height: 100px;
        }
      }

      .card--body {
        width: 100%;
      }
    }
  }
`;

export const CardsWrapperContainer = styled.div`
  height: 100%;
`;

export const CardBodyContainer = styled.div`
  padding: 32px;
  height: 100%;
  position: relative;

  &.simple-responsive {
    padding: 24px;
  }

  p {
    font-family: Sofia Pro;
    font-weight: 500;
    line-height: 150%;
    margin: 0;
    padding: 0;
    text-align: ${props => props.align || 'left'};
  }

  &.with-footer-cta {
    .card--body-wrapper {
      padding-bottom: 65px;

      &.simple-card {
        padding-bottom: 30px;
      }
    }
  }

  .card--body-wrapper {
    &.with-footer-percent,
    &.with-footer-author {
      padding-bottom: 111px;
      height: 100%;
    }
  }

  @media (max-width: 768px) {
    padding: 24px;

    &.with-footer-cta {
      .card--body-wrapper {
        padding-bottom: 47px;
      }
    }

    &.simple-responsive {
      padding: 16px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    &.simple-responsive.with-footer-cta {
      .card--body-wrapper {
        padding-bottom: 0;
      }
    }

    .card--body-wrapper {
      &.with-footer-percent,
      &.with-footer-author {
        padding-bottom: 89px;
      }
    }
  }

  @media (max-width: 576px) {
    &.with-footer-cta {
      .card--body-wrapper.icon-card--body-wrapper {
        padding-bottom: 32px;
      }
    }

    .card--body-wrapper {
      &.with-footer-author {
        padding-bottom: 65px;
      }

      &.icon-card--body-wrapper {
        display: flex;

        .icon-card--text-container {
          margin-left: 20px;

          p {
            text-align: left;
          }
        }
      }
    }
  }
`;

export const CategoryContainer = styled.div`
  margin-bottom: 7px;
  overflow: hidden;
  position: relative;

  &:before {
    content: ' ';
    width: ${props => (props.hovered ? '0' : '50px')};
    background: linear-gradient(to right, #ffffff00, #ffffffff);
    position: absolute;
    height: 100%;
    right: 0;
  }

  p {
    font-size: 13px;
    color: var(--neutral-4);
    letter-spacing: 0.05em;
    text-transform: uppercase;
    white-space: nowrap;
  }

  @media (max-width: 768px) {
    margin-bottom: 8px;

    &.simple-responsive {
      display: none;
    }
  }
`;

export const FooterContainer = styled.div`
  font-family: Sofia Pro;
  font-size: 16px;
  font-weight: bold;
  line-height: 110%;
  color: ${props => (props.hovered ? '#0076AD' : '#009de6')};
  position: absolute;
  bottom: 32px;
  text-align: ${props => props.align || 'left'};

  &.simple-responsive {
    bottom: 24px;
  }

  & > svg {
    vertical-align: middle;
    margin-left: 6px;
    margin-top: -1px;
  }

  @media (max-width: 768px) {
    font-size: 14px;
    bottom: 24px;

    &.simple-responsive {
      position: relative;
      bottom: 0;
    }
  }

  @media (max-width: 576px) {
    &.icon-card-footer {
      left: 108px;
    }
  }
`;

export const CardGroupContainer = styled.div`
  .card-group--row {
    display: flex;
    margin: 0 -20px;

    .card-group--item {
      flex: 1;
      margin: 20px 20px;
      min-width: 0;

      &.empty-item {
        margin-top: 0 !important;
        margin-bottom: 0 !important;
      }
    }
  }

  @media (max-width: 991px) {
    .card-group--row {
      margin: 0 -10px;

      .card-group--item {
        margin: 10px 10px;
      }
    }
  }

  @media (max-width: 576px) {
    .card-group--row {
      flex-direction: column;
    }
  }
`;

export const SuccessStoryCardContainer = styled.div`
  font-family: Sofia Pro;
  text-align: ${props => props.textAlign};
  width: ${props => props.width};
  max-width: 70vw;
  height: 384px;
  box-shadow: 0px 3px 10px rgba(11, 26, 33, 0.08) !important;
  top: 0;
  margin-right: 47px;

  &:hover {
    box-shadow: 0 8px 24px 8px rgba(160, 161, 188, 0.14) !important;
    top: -4px;
  }

  .success-story-card--container {
    display: flex;
    height: 100%;

    .success-story-card--image-container {
      width: 309px;
      height: 384px;
      position: relative;

      .success-story-card--company-logo-container {
        position: absolute;
        width: 150px;
        height: 150px;
        border-radius: 50%;
        background: white;
        z-index: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        left: -47px;
        bottom: -30px;
      }

      .success-story-card--image {
        width: auto;
        height: 100%;
      }
    }

    .success-story-card--body-container {
      background: white;
      width: 475px;
      padding: ${props => props.padding};
      position: relative;
      height: 100%;

      .success-story-card--content-container {
        display: flex;
        flex-direction: column;
        height: 100%;

        .success-story-card--company-logo-container {
          display: none;
        }

        .success-story-card--title-wrapper {
          overflow: hidden;
          height: 102px;
          flex: none;

          .success-story-card--title {
            font-size: 31px;
            font-weight: 900;
            line-height: 110%;
            letter-spacing: -0.04em;
            color: var(--neutral-7);
          }
        }

        .success-story-card--description-wrapper {
          flex: auto;
          overflow: hidden;
          margin: 20px 0 50px;

          .success-story-card--description {
            font-weight: 500;
            font-size: 21px;
            line-height: 150%;
            color: var(--neutral-7);
            overflow: hidden;
            margin: 0;
          }
        }

        .success-story-card--author,
        .success-story-card--company {
          font-weight: 500;
          font-size: 16px;
          line-height: 150%;
          text-align: left;
          color: var(--neutral-4);
          margin: 0;
          flex: none;
          height: 24px;
        }
      }

      .success-story-card--learn-more-button {
        width: 148px;
        height: 47px;
        background: var(--blue-primary);
        box-shadow: 0px 15px 40px rgba(11, 26, 33, 0.1);
        border-radius: 27px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        bottom: 30px;
        right: -20px;

        .success-story-card--learn-more-text {
          font-weight: bold;
          font-size: 16px;
          line-height: 110%;
          color: white;
          margin-right: 4px;
          margin-bottom: 0;
        }

        svg {
          stroke: white;
        }
      }
    }
  }

  @media (max-width: 991px) {
    margin-right: 57px;
  }

  @media (max-width: 768px) {
    .success-story-card--container {
      .success-story-card--image-container {
        .success-story-card--company-logo-container {
          width: 100px;
          height: 100px;

          svg,
          img {
            width: 60px;
          }
        }
      }

      .success-story-card--body-container {
        padding: 30px;

        .success-story-card--content-container {
          .success-story-card--title-wrapper {
            height: 85px;

            .success-story-card--title {
              font-size: 26px;
            }
          }

          .success-story-card--description-wrapper {
            .success-story-card--description {
              font-size: 20px;
            }
          }
        }

        .success-story-card--learn-more-button {
          .success-story-card--learn-more-text {
            font-size: 14px;
          }
        }
      }
    }
  }

  @media (max-width: 576px) {
    height: 361px;
    margin-right: 37px;

    .success-story-card--container {
      .success-story-card--image-container {
        display: none;
      }

      .success-story-card--body-container {
        padding: 20px;

        .success-story-card--content-container {
          .success-story-card--company-logo-container {
            display: block;
            height: 72px;
            margin-bottom: 20px;

            svg,
            img {
              height: 100%;
            }
          }

          .success-story-card--description-wrapper {
            margin: 10px 0 48px;

            .success-story-card--description {
              font-size: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-line-clamp: 6;
              -webkit-box-orient: vertical;
            }
          }
        }

        .success-story-card--learn-more-button {
          width: 128px;
          height: 39px;
          bottom: 20px;
        }
      }
    }
  }
`;

export const ToolCardContainer = styled.div`
  font-family: Sofia Pro;
  text-align: ${props => props.textAlign};
  width: ${props => props.width};
  box-shadow: 0px 3px 10px rgba(11, 26, 33, 0.08) !important;
  height: 100%;
  background: ${props => props.background} !important;
  border-radius: 10px !important;
  overflow: hidden;
  top: 0;

  &:hover {
    box-shadow: 0 8px 24px 8px rgba(160, 161, 188, 0.14) !important;
    top: -4px;
  }

  .ant-card-body {
    padding: 0 !important;
    background: transparent !important;
  }

  .tool-card--container {
    display: flex;
    flex-direction: column;

    .tool-card--image-container {
      width: 100%;
      height: 300px;
      padding: 50px 30px 0 0;

      .tool-card--image {
        width: auto;
        height: 100%;
      }
    }

    .tool-card--body-container {
      padding: 30px;

      .tool-card--content-container {
        padding-top: 10px;
        padding-bottom: 0;

        .tool-card--title {
          font-size: 39px;
          font-weight: 900;
          line-height: 110%;
          letter-spacing: -0.04em;
          color: #fff;
        }

        .tool-card--description {
          font-weight: 500;
          font-size: 16px;
          line-height: 150%;
          color: var(--blue-fourth);
        }
      }
    }
  }

  @media (max-width: 768px) {
    .ant-card-body {
      padding: 0;
    }

    .tool-card--container {
      .tool-card--body-container {
        padding: 20px;

        .tool-card--content-container {
          padding-top: 10px;

          .tool-card--title {
            font-size: 23px;
            line-height: 24px;
          }
        }
      }
    }
  }

  @media (max-width: 575px) {
    .tool-card--container {
      .tool-card--content-container {
        padding-top: 22px;
      }
    }
  }
`;
